import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export default function useCreateSelectOptions() {
  const { t } = useTranslation();

  return useCallback(
    (options: string[] | Record<string, any> = []) => {
      if (!options) return [];

      if (Array.isArray(options)) {
        if (!options.length) return [];

        return options.map((value) => ({ value, label: t(value) }));
      }

      if (!Object.keys(options).length) return [];

      return Object.entries(options).map(([key, value]) => ({
        value,
        label: t(key),
      }));
    },
    [t],
  );
}
